import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  title?: string;
  subtitle?: string;
  readBio?: string;
  bioList?: {
    profileModal?: boolean;
    profileRoundedCorner?: boolean;
    profileUrl?: string;
    profileUrlAlt?: string;
    name?: string;
    position?: string;
    bio?: string;
    link?: string;
  }[];
  backgroundColor?: string;
  textColor?: {
    bioListColor?: {
      nameColor?: string;
      positionColor?: string;
      bioColor?: string;
    };
  };
}

const propsSchema: PropsSchemaList = [
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'subtitle',
    label: 'Subtitle',
    type: types.TEXT,
  },
  {
    key: 'readBio',
    label: 'Read Bio',
    type: types.TEXT,
  },
  {
    key: 'bioList',
    label: 'Bio List',
    type: types.ARRAY,
    children: [
      {
        key: 'profileModal',
        label: 'Enable Popup Modal',
        type: types.BOOLEAN,
      },
      {
        key: 'profileRoundedCorner',
        label: 'Enable Rounded Image Corners',
        type: types.BOOLEAN,
      },
      {
        key: 'profileUrl',
        label: 'Profile URL',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'profileUrlAlt',
        label: 'Image Alternative Text (A brief description of the image to optimize search engine visibility)',
        type: types.TEXT,
      },
      {
        key: 'name',
        label: 'Name',
        type: types.TEXT,
      },
      {
        key: 'position',
        label: 'Position',
        type: types.TEXT,
      },
      {
        key: 'bio',
        label: 'Bio',
        type: types.TEXT,
      },
      {
        key: 'link',
        label: 'Learn More Link',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'backgroundColor',
    label: 'Background Color',
    type: types.COLOR_PICKER,
  },
  {
    key: 'textColor',
    label: 'Text Color',
    type: types.OBJECT,
    children: [
      {
        key: 'bioListColor',
        label: 'Bio List Color',
        type: types.OBJECT,
        children: [
          {
            key: 'nameColor',
            label: 'Name Color',
            type: types.COLOR_PICKER,
          },
          {
            key: 'positionColor',
            label: 'Position Color',
            type: types.COLOR_PICKER,
          },
          {
            key: 'bioColor',
            label: 'Bio Color',
            type: types.COLOR_PICKER,
          },
        ]
      },
    ]
  },
];

const defaultProps: Props = {
  title: 'Keynote Speaker',
  subtitle: 'Investor & Partner',
  readBio: '+ READ BIO',
  bioList: [
    {
      profileModal: true,
      profileRoundedCorner: false,
      profileUrl: 'https://genesis-cdn.ff.com/our_company/our-team-20230803/original/xf-default.jpg',
      profileUrlAlt: 'Xuefeng (XF) Chen',
      name: 'Xuefeng (XF) Chen',
      position: 'Global CEO',
      bio: `XF is acknowledged within the industry as the youngest person in charge of the China-side 
      of business in automotive joint ventures. He is a pioneer in the Chinese automotive industry and 
      possesses extensive and comprehensive corporate management experience.`,
      link: '',
    },
    {
      profileModal: true,
      profileRoundedCorner: false,
      profileUrl: 'https://genesis-cdn.ff.com/our_company/our-team-20230803/original/matthiasv03--1-.jpg',
      profileUrlAlt: 'Matthias Aydt',
      name: 'Matthias Aydt',
      position: 'Global Senior Vice President, Product Execution',
      bio: `Matthias has experiences with global automotive companies and OEM suppliers, leading teams within Project Management and Vehicle Engineering.`,
      link: '',
    },
    {
      profileModal: true,
      profileRoundedCorner: false,
      profileUrl: 'https://genesis-cdn.ff.com/our_company/our-team-20230803/original/ytv02.jpg',
      profileUrlAlt: 'YT Jia',
      name: 'YT Jia',
      position: 'Founder, Partner, Chief Product and User Ecosystem Officer',
      bio: `YT Jia (YT) is a trailblazer and a revolutionary of the Internet eco model and the smart mobility model, 
      a forward-thinking world-class strategist, serial entrepreneur who excels in cross-boundary 
      innovation in disruptive product and technology...`,
      link: '',
    },
    {
      profileModal: true,
      profileRoundedCorner: false,
      profileUrl: 'https://genesis-cdn.ff.com/our_company/our-team-20230803/original/tinmok.jpg',
      profileUrlAlt: 'Tin Mok',
      name: 'Tin Mok',
      position: 'Global User Ecosystem',
      bio: `Prior to joining FF, Tin has 15+ years of executive experience in global consumer electronics, 
      internet business and the financial technology industry, focusing on marketing, branding, 
      online-to-offline sales and internet platform operation.`,
      link: '',
    },
    {
      profileModal: true,
      profileRoundedCorner: false,
      profileUrl: 'https://genesis-cdn.ff.com/our_company/our-team-20230803/original/YunHan-default.jpg',
      profileUrlAlt: 'Yun Han',
      name: 'Yun Han',
      position: 'CFO',
      bio: `Ms. Han has held other senior accounting and finance positions at various companies and 
      spent over 13 years with PwC in its technical accounting and audit practice.`,
      link: '',
    },
  ],
  backgroundColor: '#222224',
  textColor: {
    bioListColor: {
      nameColor: 'white',
      positionColor: '#C9C9D1',
      bioColor: '#C9C9D1',
    },
  },
};

export default {
  title: 'Character Bio',
  id: 'CharacterBio',
  propsSchema,
  defaultProps,
}
